var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirusDnaHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_15_1",
    "data-name": "Component 15 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.555,
    height: 157.555,
    viewBox: "0 0 157.555 157.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 157.555,
    height: 157.555,
    fill: "#56a5cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M134.93,176.15A41.311,41.311,0,1,1,176.24,134.84,41.357,41.357,0,0,1,134.93,176.15m0-80.615a39.3,39.3,0,1,0,39.3,39.3,39.349,39.349,0,0,0-39.3-39.3",
    transform: "translate(-56.06 -56.006)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M116.753,170.151a53.489,53.489,0,1,1,53.489-53.489,53.549,53.549,0,0,1-53.489,53.489m0-104.971a51.483,51.483,0,1,0,51.483,51.483A51.541,51.541,0,0,0,116.753,65.18",
    transform: "translate(-37.883 -37.829)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M192.855,7.349a7.349,7.349,0,1,0-8.352,7.273V38.395h2.006V14.622a7.355,7.355,0,0,0,6.346-7.273m-7.349,5.343a5.343,5.343,0,1,1,5.343-5.343,5.35,5.35,0,0,1-5.343,5.343",
    transform: "translate(-106.682)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M186.508,320.792V297.019H184.5v23.773a7.349,7.349,0,1,0,2.006,0m-1,12.616a5.343,5.343,0,1,1,5.343-5.343,5.35,5.35,0,0,1-5.343,5.343",
    transform: "translate(-106.682 -177.859)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M328.063,178.182a7.354,7.354,0,0,0-7.272,6.346H297.018v2.006h23.773a7.346,7.346,0,1,0,7.272-8.352m0,12.692a5.343,5.343,0,1,1,5.343-5.343,5.349,5.349,0,0,1-5.343,5.343",
    transform: "translate(-177.858 -106.698)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M38.395,184.528H14.622a7.349,7.349,0,1,0,0,2.006H38.395ZM7.349,190.874a5.343,5.343,0,1,1,5.343-5.343,5.349,5.349,0,0,1-5.343,5.343",
    transform: "translate(0 -106.698)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M293.627,54.445a7.345,7.345,0,0,0-11.048,9.63l-16.81,16.81,1.418,1.418L284,65.493a7.345,7.345,0,0,0,9.63-11.048m-1.418,8.975a5.341,5.341,0,1,1,0-7.557,5.35,5.35,0,0,1,0,7.557",
    transform: "translate(-159.146 -31.315)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M82.163,267.327l-1.418-1.418L63.936,282.718a7.352,7.352,0,1,0,1.417,1.419ZM63.28,292.349a5.343,5.343,0,0,1-7.557-7.557h0a5.343,5.343,0,0,1,7.556,7.557",
    transform: "translate(-31.232 -159.23)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M64.7,54.44a7.355,7.355,0,1,0-.763,11.049L80.745,82.3l1.418-1.418L65.353,64.07a7.355,7.355,0,0,0-.655-9.63m-8.975,8.975A5.344,5.344,0,1,1,59.5,64.98a5.308,5.308,0,0,1-3.778-1.565",
    transform: "translate(-31.231 -31.31)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M293.627,283.374a7.356,7.356,0,0,0-9.63-.655l-16.81-16.81-1.418,1.418,16.81,16.81a7.346,7.346,0,1,0,11.048-.763m-1.418,8.975a5.341,5.341,0,1,1,0-7.557,5.35,5.35,0,0,1,0,7.557",
    transform: "translate(-159.146 -159.23)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M174.349,153.723a4.433,4.433,0,0,0-3.426,1.619,10.948,10.948,0,0,1-.09-20.031,4.444,4.444,0,1,0-.752-1.5,10.947,10.947,0,0,1-13.906-14.475,4.383,4.383,0,0,0,.593.045,4.447,4.447,0,1,0-2.159-.564,10.957,10.957,0,0,1-20.235-.164,4.437,4.437,0,0,0-2.431-8.15h0a4.44,4.44,0,1,0,.92,8.782,10.957,10.957,0,0,1-14.21,14.413,4.458,4.458,0,1,0-.7,1.494,10.959,10.959,0,0,1-.086,20.272,4.442,4.442,0,1,0,.746,1.468A10.928,10.928,0,0,1,133.168,170.4a4.434,4.434,0,0,0-1.245-.179h0a4.45,4.45,0,1,0,2.812,1.007,10.9,10.9,0,0,1,19.476-.2,4.4,4.4,0,1,0,1.65-.712,10.918,10.918,0,0,1,14.259-13.5,4.438,4.438,0,1,0,4.228-3.091M173.226,130a2.834,2.834,0,1,1-1.48,3.725,2.828,2.828,0,0,1,1.48-3.725m-16.458-17.9a2.834,2.834,0,1,1-2.834,2.834,2.834,2.834,0,0,1,2.834-2.834m-41.288,23.1a2.835,2.835,0,1,1,1.479-3.725,2.828,2.828,0,0,1-1.479,3.725M114.356,161a2.834,2.834,0,1,1,2.834-2.834A2.834,2.834,0,0,1,114.356,161m18.691,16.27a2.834,2.834,0,1,1,1.479-3.725,2.82,2.82,0,0,1-1.479,3.725m26.535-2.6a2.834,2.834,0,1,1-4.339-2.4l.878-.364a2.828,2.828,0,0,1,3.461,2.762m-30.241-58.6a2.831,2.831,0,1,1,2.6,1.712,2.834,2.834,0,0,1-2.6-1.712m28.068,42.125a12.386,12.386,0,0,0-3.608,9.506,12.394,12.394,0,0,0-18.547,0,12.387,12.387,0,0,0-12.427-13.132q-.342,0-.687.017a12.394,12.394,0,0,0,0-18.546,12.395,12.395,0,0,0,13.114-13.115,12.395,12.395,0,0,0,18.547,0,12.4,12.4,0,0,0,13.115,13.115,12.394,12.394,0,0,0,0,18.546,12.4,12.4,0,0,0-9.507,3.609M174.349,161a2.834,2.834,0,1,1,2.834-2.834A2.835,2.835,0,0,1,174.349,161",
    transform: "translate(-65.819 -66.169)",
    fill: "#325679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M188.311,164.578a.577.577,0,0,0-.8.119,6.293,6.293,0,0,1-.814.9l-6.427-5.081a6.342,6.342,0,0,1,1.074-1.208A.576.576,0,0,0,181,158.3a.565.565,0,0,0-.417.141,7.535,7.535,0,0,0-1.535,1.845.574.574,0,0,0-.09.163,7.107,7.107,0,0,0-.873,3.906l.213,3.263-2.8.177a10.87,10.87,0,0,0-1.393.179.482.482,0,0,0-.067.012,9.866,9.866,0,0,0-1.575.451,8.768,8.768,0,0,0-2.082,1.117c-.165.122-.324.249-.474.381l-.339.294a6.829,6.829,0,0,0-1.545,1.989,8.5,8.5,0,0,0-.393.854,8.7,8.7,0,0,0-.595,2.832,9.156,9.156,0,0,0,.011,1l.177,2.714-3.671.231a8.43,8.43,0,0,0-1.293.185,8.071,8.071,0,0,0-2.819,1.226,7.822,7.822,0,0,0-1.015.833.577.577,0,0,0-.011.814.593.593,0,0,0,.814.011,6.706,6.706,0,0,1,.536-.467l6.632,5.243a6.316,6.316,0,0,1-.644.815.576.576,0,0,0,.421.968h.021a.573.573,0,0,0,.4-.183,7.182,7.182,0,0,0,1.95-5.408l-.214-3.28,3.556-.224a8.154,8.154,0,0,0,5.689-3.013l.158-.2a5.822,5.822,0,0,0,.766-1.075c.012-.02.023-.039.031-.054a8.558,8.558,0,0,0,.637-1.488,9.073,9.073,0,0,0,.408-3.409l-.166-2.535,3.449-.217a7.635,7.635,0,0,0,1.48-.24.384.384,0,0,0,.057-.016,7.494,7.494,0,0,0,4.039-2.751.575.575,0,0,0-.121-.805m-20.968,20.65a5.956,5.956,0,0,1-.4,1.429l-6.163-4.872a6.937,6.937,0,0,1,1.479-.574Zm-.157-4.46.2,3.023-3.556-2.811Zm3.724-1.484-2.547.161-.15-2.292Zm3.952-1.07a6.439,6.439,0,0,1-2.286.918l-4.377-3.46a7.54,7.54,0,0,1,.5-2.178l.047-.116Zm2.394-2.3a4.588,4.588,0,0,1-.39.494l-.164.2a10.211,10.211,0,0,1-.893.885l-6.531-5.162a5.5,5.5,0,0,1,1.041-1.236l.341-.3.061-.052Zm1.143-3.291a7.707,7.707,0,0,1-.587,2.261l-6.1-4.825a7.881,7.881,0,0,1,1.159-.546h0a8.642,8.642,0,0,1,1.155-.348Zm1.04-5.173-.2-3.068,3.609,2.853-.063,0Zm-1.018,3.723-2.823-2.232,2.666-.168Zm7.32-4.862a6.374,6.374,0,0,1-1.4.637l-5.049-3.992a5.93,5.93,0,0,1,.411-1.418Zm-7.388,9.631Z",
    transform: "translate(-94.761 -94.791)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirusDnaHighlight);
export default __webpack_public_path__ + "static/media/virus-dna-highlight.e08124232b50b3d29a75c235e0128009.svg";
export { ForwardRef as ReactComponent };